import { useState, useEffect, useRef } from 'react';

/**
 * Anime un nombre de 0 → target avec easeOutExpo.
 * Partagé par Dashboard, Contacts, Campaigns, Strategy, Birthdays.
 */
export default function useCountUp(target, duration = 900) {
  const [count, setCount] = useState(0);
  const frameRef = useRef(null);

  useEffect(() => {
    if (target === 0) { setCount(0); return; }
    const start = performance.now();
    const animate = (now) => {
      const t = Math.min((now - start) / duration, 1);
      const eased = t === 1 ? 1 : 1 - Math.pow(2, -10 * t); // easeOutExpo
      setCount(Math.round(eased * target));
      if (t < 1) frameRef.current = requestAnimationFrame(animate);
      else setCount(target);
    };
    frameRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frameRef.current);
  }, [target, duration]);

  return count;
}
